import constate from "constate";

export interface WorkerMenuPriviliges {}

export function useGetWorkerMenuPriviliges(): WorkerMenuPriviliges {
  return {};
}

export const [WorkerMenuPriviligesProvider, useWorkerMenuPriviligesProviderContext] = constate(
  useGetWorkerMenuPriviliges
);
